import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

export interface ITextWhithChildrenItem {
    text?: string;
    children?: ITextWhithChildrenItem[];
}

/**
 * Displays a ul/li tree according to given items. If 'text' is missing at some level, the tree is flattened with children. Node's text is rendered as innerHTML.
 */
@Component({
    selector: 'text-with-children',
    template: `
        <ul *ngIf="values?.length && someValuesWithText">
            <li *ngFor="let value of values">
                <span [innerHTML]="value.text | safeHtml"></span>
                <text-with-children *ngIf="value.children?.length" [values]="value.children"></text-with-children>
            </li>
        </ul>
        <text-with-children *ngIf="values?.length && !someValuesWithText" [values]="allValuesChildren"></text-with-children>
    `,
    styles: []
})
export class TextWithChildrenComponent implements OnChanges {

    @Input()
    public values?: ITextWhithChildrenItem[];

    public someValuesWithText: boolean;
    public allValuesChildren: ITextWhithChildrenItem[];

    public ngOnChanges(changes: SimpleChanges): void {

        if (!changes.values || !changes.values.currentValue) {
            return;
        }

        const curValues: ITextWhithChildrenItem[] = changes.values.currentValue;
        this.someValuesWithText = curValues.some((value: ITextWhithChildrenItem) => !!value.text);
        this.allValuesChildren = [];
        curValues
            .filter((item: ITextWhithChildrenItem) => item.children)
            .forEach((value: ITextWhithChildrenItem) => {
                this.allValuesChildren.push(...value.children);
            });
    }

}
